<template>
  <div class="about">

    <div class="infoCont">
      <router-link to="/">
        <p>Go home</p>
      </router-link>
    </div>

    <div class="infoCont">

    </div>
  </div>
</template>

<script>

export default {
  name: "About",
  title: "Nethanzêl", 
  components: {
  },
  mounted() { 
  },
  beforeDestroy() {
  }
}
</script>

<style scoped lang="scss">

.about {
  mix-blend-mode: difference;
  will-change: opacity;
  padding-top: 50px;
  height: 200vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
}


.infoCont {
  border: 2px solid #fff;
  width: 75%;
  height: auto;
  padding: 15px 10px;
  background: #99999944;
  margin: 15px 0;
  height: 200px;
}


@media screen and (max-width: 770px) {

  .about {
    mix-blend-mode: difference;
    will-change: opacity;
    padding-top: 0;
    height: 200vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

}

</style>
